import { render, staticRenderFns } from "./LeaveApproveView.vue?vue&type=template&id=232562d4&"
import script from "./LeaveApproveView.vue?vue&type=script&lang=js&"
export * from "./LeaveApproveView.vue?vue&type=script&lang=js&"
import style0 from "./LeaveApproveView.vue?vue&type=style&index=0&id=232562d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports